module.exports = __webpack_public_path__ + "img/takeyama-fusaemon-sensei.242857df.jpg";